const authentication = require('../../../react-azure-adb2c2').default;

export const update = (values: any) => {
  // alert( JSON.stringify(value))
  // const url = `http://localhost:5000/v1/t/eigyou/update/` + values.before_owner_id + "/" + values.eigyou_no;
   const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/t/eigyou/update/` + values.before_owner_id + "/" + values.eigyou_no;

  var formData = new FormData();
  values.files.forEach((item: any) => {
    // File型（新規アップロード）の場合のみ append
    if (item.file instanceof File) {
      formData.append('files', item.file);
      formData.append('remarks', item.remarks || '');
    }
  });

  // 既存ファイル情報は別のキーで送る（JSON化してボディに入れる）
  const existingFiles = values.files.filter((item: any) => !item.file);
  formData.append('existing_files', JSON.stringify(existingFiles));

  // JSONオブジェクトは文字列化して送る
  formData.append('detail', JSON.stringify(values.detail));
  formData.append('type', values.type);

  const token = authentication.getAccessToken();

  return fetch(url, {
      method: 'put',
      body: formData,

      // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
      headers: { 'Authorization': 'Bearer ' + token },

  }).then(res => res.json())
      .then(payload => ({ payload }))
      .catch(error => ({ error }));

};



export const confirmers = (value: any) => {
  // alert( JSON.stringify(value))
  // const url = `http://localhost:5000/v1/t/eigyou/updateconfirmers/` + value.before_owner_id + "/" + value.eigyou_no;
  const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/t/eigyou/updateconfirmers/` + value.before_owner_id + "/" + value.eigyou_no;

  const token = authentication.getAccessToken();

  return fetch(url, {
      method: 'put',
      body: JSON.stringify(value),

      headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  }).then(res => res.json())
      .then(payload => ({ payload }))
      .catch(error => ({ error }));

};

export const bookmarks = (value: any) => {
  // alert( JSON.stringify(value))
  // const url = `http://localhost:5000/v1/t/eigyou/updatebookmarks/` + value.before_owner_id + "/" + value.eigyou_no;
  const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/t/eigyou/updatebookmarks/` + value.before_owner_id + "/" + value.eigyou_no;

  const token = authentication.getAccessToken();

  return fetch(url, {
      method: 'put',
      body: JSON.stringify(value),

      headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  }).then(res => res.json())
      .then(payload => ({ payload }))
      .catch(error => ({ error }));

};

export const deleteeigyou = (value: any) => {
  // console.log(value)
  // const url = `http://localhost:5000/v1/t/eigyou/delete/` + value.before_owner_id + "/" + value.eigyou_no;
  const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/t/eigyou/delete/` + value.before_owner_id + "/" + value.eigyou_no;
  
  const token = authentication.getAccessToken();

  return fetch(url, {
      method: 'delete',
      // body: JSON.stringify(value),

      headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  }).then(res => res.json())
      .then(payload => ({ payload }))
      .catch(error => ({ error }));

};

export const insert = (values: any) => {

  console.log(values)
  // const url = `http://localhost:5000/v1/t/eigyou/insert`;
  const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/t/eigyou/insert`;

  const token = authentication.getAccessToken();

  var formData = new FormData();


  // 複数ファイル＋備考を送る
  values.files.forEach((item:any) => {
    formData.append('files', item.file); // ← 修正
    formData.append('remarks', item.remarks || '');
  });

  // JSONオブジェクトは文字列化して送る
  formData.append('detail', JSON.stringify(values.detail));
  formData.append('type', values.type);

    // console.log("データ",formData)
  // return 
  return fetch(url, {
      method: 'post',
      // body: JSON.stringify(value),
      body: formData,

      // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
      headers: { 'Authorization': 'Bearer ' + token },

  }).then(res => res.json())
      .then(payload => ({ payload }))
      .catch(error => ({ error }));

};

// export const insert = (value: any) => {

//   console.log(value)
//   const url = `http://localhost:5000/v1/t/eigyou/insert`;
// //   const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/t/eigyou/insert`;

//   const token = authentication.getAccessToken();

//   return fetch(url, {
//       method: 'post',
//       body: JSON.stringify(value),

//       headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

//   }).then(res => res.json())
//       .then(payload => ({ payload }))
//       .catch(error => ({ error }));

// };

// export const update = (value: any) => {
//   // alert( JSON.stringify(value))
//   const url = `http://localhost:5000/v1/t/eigyou/update/` + value.before_owner_id + "/" + value.eigyou_no;
// //   const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/t/eigyou/update/` + value.before_owner_id + "/" + value.eigyou_no;

//   const token = authentication.getAccessToken();

//   return fetch(url, {
//       method: 'put',
//       body: JSON.stringify(value),

//       headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

//   }).then(res => res.json())
//       .then(payload => ({ payload }))
//       .catch(error => ({ error }));

// };